import React from "react";

import Divider from "antd/es/divider";
import cn from "classnames";

import { EntityType } from "@mapmycustomers/shared/enum";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { RegularSavedFilter } from "@mapmycustomers/shared/types/viewModel/SavedFilter";

import SavedFilterButton from "./components/SavedFilterButton";
import styles from "./QuickFilterBar.module.scss";

interface Props {
  className?: string;
  entityType?: EntityType;
  implicitFilterFields?: IField[];
  savedFilters: RegularSavedFilter[];
}

const QuickFilterBar: React.FC<Props> = ({
  children,
  className,
  entityType,
  implicitFilterFields,
  savedFilters,
}) => {
  return (
    <div className={cn(styles.container, className)}>
      {savedFilters.map((savedFilter) => (
        <SavedFilterButton
          implicitFilterFields={implicitFilterFields}
          key={`quick-saved-filter-${savedFilter.id}`}
          savedFilter={savedFilter}
        />
      ))}
      {savedFilters.length && entityType !== EntityType.ACTIVITY ? (
        <Divider className={styles.divider} type="vertical" />
      ) : null}
      {children}
    </div>
  );
};

export default QuickFilterBar;
